import { useEffect, useState } from "react";
import {
	DataGrid,
	ruRU,
	GridToolbarContainer,
	GridToolbarColumnsButton,
	GridToolbarFilterButton,
	GridToolbarExport,
	GridToolbarDensitySelector,
} from "@mui/x-data-grid";
import {
	getUploadTable,
	hrefStringForFileDownload,
	deleteFile,
	hrefStringForFileOpen,
} from "./CommonFunc";
import EditRow from "./Dialogs/EditRow";
import MainGate from "../AITextAnalyse";

function UploadTable({ rowSelectionModel, setRowSelectionModel, ...props }) {
	//states
	const [rows, setRows] = useState([]);
	const [aiDialog, setAiDialog] = useState(false);
	const [currentFile, setCurrentFile] = useState();
	const [editable, setEditable] = useState(false);

	//#region functions
	const fillRows = async () => {
		let result = await getUploadTable();
		result = result.reverse().map((e, i) => ({
			...e,
			id: i,
			USER_DATE: new Date(e.USER_DATE),
			CONT_SIZE: (+e.CONT_SIZE / 1024 / 1024).toFixed(2),
		}));
		setRows(result ?? []);
	};

	const handleDeleteFile = async (id) => {
		if (window.confirm("Вы действительно хотите удалить файл?")) {
			await deleteFile(id);
			fillRows();
		}
	};
	//#endregion

	//#region effects
	useEffect(() => {
		fillRows();
		window.addEventListener("fileUploaded", fillRows);
		return () => {
			window.removeEventListener("fileUploaded", fillRows);
		};
	}, []);
	//#endregion

	//components
	function CustomToolbar() {
		//variable
		const selectedRowObject = rows[rowSelectionModel[0]];
		return (
			<GridToolbarContainer>
				<div className='row-custom-toolbar'>
					<div style={{ color: "var(--font-color)" }}>
						Действия для выделенного файла:
					</div>
					<a
						className='file-download-link'
						href={`${hrefStringForFileDownload}/${selectedRowObject.ID}`}
					>
						Скачать файл
					</a>
					<a
						className='file-download-link'
						href={`${hrefStringForFileOpen}/${selectedRowObject.ID}`}
						target='_blank'
					>
						Открыть файл
					</a>
					<span
						className='file-download-link'
						style={{
							cursor: "pointer",
							display:
								selectedRowObject.EXT === "pdf" ? "inline-block" : "none",
						}}
						onClick={async () => {
							setCurrentFile({
								name: selectedRowObject.DESCRIPTION,
								fileId: selectedRowObject.ID,
							});
							setAiDialog(true);
						}}
					>
						ИИ анализ
					</span>
					<button
						className='file-download-link button-link'
						onClick={() => handleDeleteFile(selectedRowObject.ID)}
					>
						Удалить файл
					</button>
				</div>
			</GridToolbarContainer>
		);
	}

	//#region table columns
	const columns = [
		{
			field: "DESCRIPTION",
			headerName: "Пользовательское имя файла",
			width: 400,
			// editable: true,
		},
		{
			field: "USER_DATE",
			headerName: "Дата",
			width: 100,
			sortable: false,
			type: "date",
			// editable: true,
		},
		{
			field: "EXT",
			headerName: "Расширение",
			width: 120,
			sortable: false,
		},
		{
			field: "CONT_SIZE",
			headerName: "Размер файла, Мб",
			width: 150,
			sortable: false,
		},
		{
			field: "ORIG_NAME",
			headerName: "Оригинальное имя файла",
			width: 200,
			sortable: false,
		},
		// {
		// 	field: "DOWNLOAD",
		// 	headerName: "",
		// 	width: 150,
		// 	sortable: false,
		// 	renderCell: (params) => {
		// 		return (
		// 			<a
		// 				className='file-download-link'
		// 				href={`${hrefStringForFileDownload}/${params.row.ID}`}
		// 			>
		// 				Скачать файл
		// 			</a>
		// 		);
		// 	},
		// },
		// {
		// 	field: "OPEN",
		// 	headerName: "",
		// 	width: 150,
		// 	sortable: false,
		// 	visible: true,
		// 	renderCell: (params) => {
		// 		return (
		// 			<a
		// 				className='file-download-link'
		// 				href={`${hrefStringForFileOpen}/${params.row.ID}`}
		// 				target='_blank'
		// 			>
		// 				Открыть файл
		// 			</a>
		// 		);
		// 	},
		// },
		// {
		// 	field: "AI",
		// 	headerName: "",
		// 	width: 150,
		// 	sortable: false,
		// 	visible: true,
		// 	renderCell: (params) => {
		// 		return (
		// 			<span
		// 				className='file-download-link'
		// 				style={{
		// 					cursor: "pointer",
		// 					visibility: params.row.EXT === "pdf" ? "visible" : "hidden",
		// 				}}
		// 				onClick={async () => {
		// 					// const content = await getFileForAi(params.row.ID);
		// 					// const response = await fetch(
		// 					// 	`${hrefStringForFileOpen}/${params.row.ID}`,
		// 					// 	{
		// 					// 		method: "GET",
		// 					// 		headers: {
		// 					// 			"Content-Type": "application/json",
		// 					// 		},
		// 					// 	}
		// 					// );
		// 					// const pdfBlob = await response.blob(); // Get the response as a Blob
		// 					// // const blob = new Blob([content], { type: "application/msword" });
		// 					// const file = new File(
		// 					// 	[pdfBlob],
		// 					// 	params.row.DESCRIPTION + ".pdf",
		// 					// 	{ type: "application/pdf" }
		// 					// );
		// 					setCurrentFile({
		// 						name: params.row.DESCRIPTION,
		// 						fileId: params.row.ID,
		// 					});
		// 					setAiDialog(true);
		// 				}}
		// 			>
		// 				ИИ анализ
		// 			</span>
		// 		);
		// 	},
		// },
		// {
		// 	field: "DELETE",
		// 	headerName: "",
		// 	width: 150,
		// 	sortable: false,
		// 	renderCell: (params) => {
		// 		return (
		// 			<button
		// 				className='file-download-link button-link'
		// 				onClick={() => handleDeleteFile(params.row.ID)}
		// 			>
		// 				Удалить файл
		// 			</button>
		// 		);
		// 	},
		// },
	];
	//#endregion

	return (
		<div
			style={{
				height: "100%",
				display: "flex",
				flexDirection: "column",
				alignItems: "stretch",
				gap: "1em",
				// filter: aiDialog && "blur(10px)",
			}}
		>
			<div style={{ width: "100%", height: "100%" }}>
				<DataGrid
					// ref={apiRef}
					rows={rows}
					columns={columns}
					disableColumnMenu={true}
					localeText={ruRU.components.MuiDataGrid.defaultProps.localeText}
					rowSelectionModel={rowSelectionModel}
					// editMode='row'
					onRowSelectionModelChange={(newRowSelectionModel) => {
						setRowSelectionModel(newRowSelectionModel);
						console.log(newRowSelectionModel);
					}}
					onRowEditStop={(params, event) => {
						console.log(params);
						console.log(event);
					}}
					onRowEditCommit={(e) => {
						console.log("Commit", e);
					}}
					slots={
						rowSelectionModel.length > 0
							? {
									toolbar: CustomToolbar,
							  }
							: null
					}
				/>
			</div>
			{editable ? (
				<EditRow
					data={rows[rowSelectionModel[0]] ?? {}}
					setEditable={setEditable}
					fillRows={fillRows}
				/>
			) : null}

			{aiDialog ? (
				<MainGate file={currentFile} setAiDialog={setAiDialog} />
			) : null}
		</div>
	);
}

export default UploadTable;
